import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const headerAnimations = () => {
  const getDesktopHeader = document.getElementById("amthal-header-desktop");
  const getMobileHeader = document.getElementById("amthal-header-mobile");
  const getStatementStart = document.getElementById(
    "amthal-statement-column-start"
  );
  const getStatementEnd = document.getElementById(
    "amthal-statement-column-end"
  );

  if (getDesktopHeader) {
    const animateDesktopHeader = ScrollTrigger.create({
      start: "top var(--wp--custom--spacing--p-y)",
      end: 999999,
      toggleClass: {
        className: "amthal-header-desktop-scrolled",
        targets: ".amthal-header-desktop",
      },
    });
  }

  if (getMobileHeader) {
    const animateMobileHeader = ScrollTrigger.create({
      start: "top var(--wp--custom--spacing--p-y)",
      end: 999999,
      toggleClass: {
        className: "amthal-header-mobile-scrolled",
        targets: ".amthal-header-mobile",
      },
    });
  }
};
